import React from "react";

const Transaction = ({ title }) => {
  return (
    <div className="transaction_section">
      <h2>{title}</h2>
    </div>
  );
};

export default Transaction;
